import {create_log, get_insure_type} from '../actions/login';
import Cookies from 'js-cookie';
const LOGIN_TYPE = {
    1: 'Enterprise',
    2: 'economics',
    3: 'insurance',
    4: 'Home',
    5: 'Expert',
    7: 'Gov',
};


const COOKIE_TYPE = {
    1: 'enterprise',
    2: 'economics',
    3: 'insurance',
    4: 'home',
    5: 'expert',
    7: 'goverment',
}

const options = {
    path: '/',
    expires: 2 / 24,
};
function titleCase5(str) {
    return str.toLowerCase().replace(/( |^)[a-z]/g, (L) => L.toUpperCase());
}
function setCookie(key, value) {
    Cookies.set(key, value, options);
}
export default function auth(data) {
    const { token, organ,type } = data;

    if(organ){
        const organType = String(organ.type);

        const pattern = String(organ.pattern);

        //企业非保险用户
        if (organType === '1' && pattern !== '1') {
            setCookie('token', token);
            location.href = '/EnterpriseNotInsure';
            localStorage.setItem(token, JSON.stringify(getData(data)));
            return;
        }

        // 企业端 登录 记录日志
        if(organType == '1' && pattern == '1' ){
            create_log({
                operate_type:'业务操作',
                operate_desc:'登录',
                token
            })
        }

        //老监管用户
        if (organType === '4') {
            setCookie('token', token);
            localStorage.setItem(token, JSON.stringify(getData(data)));
            location.href = '/Home';
            return;
        }

        //保险经纪用户，获取不同险种
        if (['2', '3'].includes(organType)) {
            get_insure_type({ token }).then((result) => {
                if (result.ret == 0) {
                    const list = result.data;
                    for (let i = 0; i < list.length; i++) {
                        setCookie(
                            COOKIE_TYPE[organ.type] + '-' + list[i].insureType + '-token',
                            token,
                        );
                    }
                    location.href =
                        '/' +
                        titleCase5(LOGIN_TYPE[organ.type]) +
                        titleCase5(list[0].insureType);
                }
            });
            return;
        }

        setCookie(COOKIE_TYPE[organ.type] + '-token', token, options);

        location.href = '/' + LOGIN_TYPE[organ.type];
    }else{
        if (0 < type && type < (1 << 30)) {

            setCookie(COOKIE_TYPE[5] + '-token', token, options);

            location.href = '/' + LOGIN_TYPE[5];
        }
    }




}

function getData(data) {
    let {
        token,
        userID,
        userName,
        organMemberType,
        organ,
        group = {},
        profile,
        groupMember: { roleType, roleID = '', roleName = '' },
        firstLogin,
    } = data;

    let {
        typeID,
        typeName,
        scopeGrid = [],
        imagePath: organLogo,
        platformName,
        supervisionUnit,
    } = organ?.addon || {};

    const coInsurance = organ?.coInsurance || {};
    const grid = organ?.grid || {};
    let { groupID, groupName } = group || {};

    scopeGrid = scopeGrid.join(',');

    const { lat, lng, code } = grid || {};

    return {
        token,
        firstLogin,
        userID,
        userName,
        organMemberType,
        roleType,
        roleID,
        code,

        organType: organ?.type,
        organID: organ?.organID,
        organName: organ?.organName,
        gridID: organ?.gridID,
        gridName: organ?.gridName,
        patternID: organ?.patternID,

        supervisionUnit,
        platformName,

        coInsuranceName: coInsurance?.name,
        coInsuranceID: coInsurance?.coID,
        coILogo: coInsurance?.logo,

        organLogo,

        typeID,
        typeName,

        groupID,
        groupName,
        position: `${lng},${lat}`,
        scopeGrid,
        roleName,

        profile,
    };
}
